import React from 'react';

function PaginationSection({ 
    totalCount, 
    itemsPerPage, 
    currentPage, 
    onPageChange,
    onArrow 
}) {
    const totalPages = Math.ceil(totalCount / itemsPerPage);
    const maxPageNumbers = 5; // 한 번에 보여줄 페이지 번호 개수

    // 현재 페이지를 중심으로 보여줄 페이지 번호들 계산
    const getPageNumbers = () => {
        let startPage = Math.max(1, currentPage - Math.floor(maxPageNumbers / 2));
        let endPage = startPage + maxPageNumbers - 1;

        if (endPage > totalPages) {
            endPage = totalPages;
            startPage = Math.max(1, endPage - maxPageNumbers + 1);
        }

        return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    };

    const pageNumbers = getPageNumbers();

    return (
        <div className="pagination">
            <button 
                className="pagination_btn first"
                onClick={() => onArrow(1)}
                disabled={currentPage === 1}
            >
                <span className="blind">처음</span>
            </button>
            <button 
                className="pagination_btn prev"
                onClick={() => onArrow(currentPage - 1)}
                disabled={currentPage === 1}
            >
                <span className="blind">이전</span>
            </button>

            <div className="pagination_nums">
                {pageNumbers.map(pageNum => (
                    <button
                        key={pageNum}
                        className={`page_num ${pageNum === currentPage ? 'active' : ''}`}
                        onClick={() => onPageChange(pageNum)}
                    >
                        {pageNum}
                    </button>
                ))}
            </div>

            <button 
                className="pagination_btn next"
                onClick={() => onArrow(currentPage + 1)}
                disabled={currentPage === totalPages}
            >
                <span className="blind">다음</span>
            </button>
            <button 
                className="pagination_btn last"
                onClick={() => onArrow(totalPages)}
                disabled={currentPage === totalPages}
            >
                <span className="blind">마지막</span>
            </button>
        </div>
    );
}

export default PaginationSection;